import React from 'react';
import ZIcon from './custom/ZIcon.js';
import JTypes from './custom/JTypes.js';
import ZButtonPresser from "components/zobject/custom/ZButtonPresser.js";
import XYInterface from "components/zobject/custom/XYInterface.js";
import MultiXYInterface from "components/zobject/custom/MultiXYInterface.js";
import Vec3 from './custom/Vec3.js';
import Vec2 from './custom/Vec2.js';
import ZEnvelopeComponent from "components/zobject/custom/ZEnvelopeComponent.js";
import VarzComponent from "components/zobject/custom/varz/VarzComponent.js";
import TextureLoader from './custom/TextureLoader.js';
import ZSDFBuilder from './custom/ZSDFBuilder.js';
import ZMixButtons from "components/zobject/custom/ZMixButtons.js";
import ZPad from "./custom/ZPad.js";
import InstanceSubPatch from './custom/InstanceSubPatch.js';
import ZSystem5 from "./custom/ZSystem5.js";
import ZSubMix from "./custom/ZSubMix.js";
import ZMatrix from './custom/ZMatrix.js';
import ZRollComponent from './custom/ZRollComponent.js';
import ZTracker from "components/tracker/ZTracker.js";
import ZTidal from './custom/ZTidal.js';
import ZSampleBank from './custom/ZSampleBank.js';
import ZToggleComponent from "./ZToggleComponent.js";
import ZCirklon from './custom/ZCirklon.js';
import ZDPad from './custom/ZDPad.js';
import ZJRepl from './custom/ZJRepl.js';
import ZMacroComponent from './custom/ZMacroComponent.js';
import ZPatterns from './custom/ZPatterns.js';
import ClosedSubPatch from '../subpatch/ClosedSubPatch.js';
import ZCanvasComponent from "./custom/ZCanvasComponent.js";
import ZTrackComponent from "./custom/ZTrackComponent.js";
import ZCanvas3DComponent from "./custom/ZCanvas3DComponent.js";
import ZColorComponent from "./custom/ZColorComponent.js";
import ZScriptComponent from "./custom/ZScriptComponent.js";
import ZShaderMaterialComponent from "./custom/ZShaderMaterialComponent.js";
import ZNFTComponent from "components/nft/ZNFTComponent.js";
import JakiGridComponent from "components/effects/jaki/JakiGridComponent.js";
import PadComponent from "components/pads/PadComponent.js";
import CoreJakiComponent from "components/effects/jaki/CoreJakiComponent.js";
import DrumRouter from "components/effects/jaki/DrumRouter.js";
import Rules from "components/effects/jaki/Rules.js";
import CustomSubPatch from 'components/subpatch/CustomSubPatch.js';
import AnnotationComponent from "components/track/AnnotationComponent.js"
import FiguresObject from "components/effects/jaki/FiguresObject.js";
import JakiGraphics from "components/effects/jaki/JakiGraphics.js";
import JSnapshotComponent from './custom/JSnapshotComponent.js';

export const getCustomZObject = (zobject, width, height, containerRef, setOverflow) => {
    switch (zobject.name) {
    case "jparams":
        return (
            <DrumRouter isDraggable={false}
                        sequencerEngine={zobject.sequencerEngine}
                        effect={{jakiParams: zobject.effect}}/>
        );
    case "gl.sdfBuilder":
        return zobject.effect && <ZSDFBuilder
              sequencerEngine={zobject.sequencerEngine}
                                builder={zobject.effect}/>;
        ;
    case "sdf.builder":
        return zobject.effect && <ZSDFBuilder
              sequencerEngine={zobject.sequencerEngine}
                                builder={zobject.effect}/>;
        ;
    case "submix":
        return (
            <ZSubMix zobject={zobject}/>
        );
    case "mixbuttons":
        return (
            <ZMixButtons zobject={zobject}/>
        );
    case "icon":
        return (
            <ZIcon zobject={zobject}/>
        );
    case "system5":
        return (
            <ZSystem5 zobject={zobject}/>
        );
    case "macro":
        return (
            <ZMacroComponent zobject={zobject} macro={zobject.effect}/>
        );
    case "jsnapshot":
        return (
            <JSnapshotComponent jsnapshot={zobject.effect}/>
        );

    case "interface.xy":
        return (
            <XYInterface zobject={zobject}/>
        );
    case "interface.multiXY":
        return (
            <MultiXYInterface zobject={zobject}/>
        );
    case "buttonPresser":
        return (
            <ZButtonPresser zobject={zobject}/>
        );
    case "jrules":
        return (
            <Rules
              effect={{... zobject, rules: [zobject.effect]}}
              sequencerEngine={zobject.sequencerEngine}
              track={zobject.subSequence}
            />
        );
    case "jtypes":
        return (
            <JTypes
              jtypes={zobject.effect}
              sequencerEngine={zobject.sequencerEngine}
              track={zobject.subSequence}
            />
        );
    case "envelope":
        return (
            <ZEnvelopeComponent zobject={zobject} zenvelope={zobject.effect}/>
        );
    case "vec3":
        return (
            <Vec3 zobject={zobject} vec3={zobject.effect}/>
        );
    case "vec2":
        return (
            <Vec2 zobject={zobject} vec2={zobject.effect}/>
        );
    case "jfigures":
        return (
            <FiguresObject
              zobject={zobject}
              effect={{... zobject, figures: zobject.effect}}
              setOverflow={setOverflow}
              sequencerEngine={zobject.sequencerEngine}
              track={zobject.subSequence}
            />
        );
    case "matrix":
        return (
            <ZMatrix zobject={zobject}/>
        );
    case "ztracker":
        return (
            <ZTracker zobject={zobject}/>
        );
    case "roll":
        return (
            <ZRollComponent zobject={zobject}/>
        );
    case "toggle":
        return (
            <ZToggleComponent toggle={zobject.effect}/>
        );
    case "jgraphics":
        return (
            <JakiGraphics
              height={height}
              width={width}
              jgraphics={zobject.effect}
              sequencerEngine={zobject.sequencerEngine}
              track={zobject.subSequence}
            />
        );
    case "comment":
        return (
            <AnnotationComponent
              attributes={zobject.attributes}
              annotation={zobject.effect}/>
        );
    case "sampleBank":
        return (
            <ZSampleBank
              sampleBank={zobject.effect}/>);
    case "jgrid":
        return (
            <JakiGridComponent
              grid={zobject.effect}/>
        );
    case "dpad":
        return (
            <ZDPad
              dpad={zobject.effect}/>
        );
    case "jrepl":
        return (
            <ZJRepl
              jrepl={zobject.effect}/>
        );
    case "jaki":
        return (
            <CoreJakiComponent
              setOverflow={setOverflow}
              effect={zobject.effect}/>
        );
    case "pad":
        return (
            <ZPad
              zobject={zobject}
              scrollContainer={containerRef}
              padWrapper={zobject.effect}/>
        );
    case "nft":
        return (
            <ZNFTComponent
              zobject={zobject}/>
        );
    case "color":
        return (
            <ZColorComponent
              zcolor={zobject.effect}/>
        );
    case "canvas":
        return (
            <ZCanvasComponent
              zobject={zobject}/>
        );
    case "three.canvas":
        return (
            <ZCanvas3DComponent
              zobject={zobject}/>
        );
    case "three.shaderMaterial":
        return (
            <ZShaderMaterialComponent
              zobject={zobject}/>
        );
    case "script":
        return (
            <ZScriptComponent
              zobject={zobject}/>
        );
    case "instancedSubpatch":
        return (<InstanceSubPatch instance={zobject.effect}/>);
    case "subpatch":
        if (zobject.effect && zobject.effect.isCustom) {
            return (<CustomSubPatch  subpatch={zobject.effect}/>);
        } else if (zobject.effect) {
            return (<ClosedSubPatch subpatch={zobject.effect}/>);
        }
        break;
    case "track":
        return (<ZTrackComponent
                  zobject={zobject}
                  track={zobject.effect} containerRef={containerRef}/>);
    case "cirklon":
        return (<ZCirklon zobject={zobject} object={zobject.effect} containerRef={containerRef}/>);
    case "three.textureLoader":
        return (<TextureLoader zobject={zobject} textureLoader={zobject.effect} containerRef={containerRef}/>);
    case "varz":
        return (<VarzComponent zobject={zobject} pattr={zobject.subSequence.pattr} containerRef={containerRef}/>);
    case "tidal":
        return (<ZTidal tidal={zobject.effect} zobject={zobject}/>);
    case "patterns":
        return (<ZPatterns object={zobject} containerRef={containerRef} primaryColor={zobject.attributes["primary-color"]} secondaryColor={zobject.attributes["secondary-color"]} />);
    }
    return undefined;
};
